import { useState } from "react";
import { Flex, Image, SimpleGrid, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Button } from "@digital-services-gard-as/anchor-react";

import gardLogo from "../assets/gard_logo.png";
import { ActOnBehalfOfButton, ActOnBehalfOfText } from "@/components/actOnBehalfOf/ActOnBehalfOf";
import { RelatedCompanyDto } from "@/api/usersApi";
import { Notification } from "@/components/Notification";
import { UserMenu } from "@/components/UserMenu";
import { isFeatureFlagEnabled } from "@/utils/featureFlags";

type NavbarProps = {
    isAuthenticated: boolean;
    profileName?: string;
    profileEmail?: string;
    onSignout: () => void;
    onSignin: () => void;
    onNavigate: () => void;
    isAuthLoading: boolean;
};

export const Navbar = ({
    isAuthenticated,
    profileName,
    profileEmail,
    onSignout,
    onSignin,
    onNavigate,
    isAuthLoading
}: NavbarProps) => {
    const [isActingOnBehalfOf, setIsActingOnBehalfOf] = useState<RelatedCompanyDto>();
    const { t } = useTranslation();

    return (
        <Flex justify="space-between" w="100%" align="center" maxWidth={{ base: "100%", lg: "110rem" }} px="2rem">
            <Flex align="flex-end" gap="16px" py="19px" onClick={onNavigate} _hover={{ cursor: "pointer" }}>
                <Image
                    src={gardLogo}
                    alt="Gard logo"
                    className="gardLogo"
                    maxH="3.5rem"
                    h="3.5rem"
                    objectFit="contain"
                />
                <Text fontSize="18px" fontWeight={700} whiteSpace="nowrap" lineHeight="1" pb="0.5rem">
                    {t("claimsInvoicing")}
                </Text>
            </Flex>
            {isAuthenticated ? (
                <SimpleGrid columns={{ sm: 1, lg: 1 }} gap={{ sm: "0.5rem", lg: "1.5rem" }}>
                    {isAuthLoading ? (
                        <Flex alignItems="center">
                            <Spinner />
                        </Flex>
                    ) : (
                        <Flex gap={4} flexDir="row" align="center">
                            <Flex>
                                <ActOnBehalfOfButton setIsActingOnBehalfOf={setIsActingOnBehalfOf} />
                            </Flex>
                            <Flex flexDir="column">
                                {isActingOnBehalfOf && <ActOnBehalfOfText isActingOnBehalfOf={isActingOnBehalfOf} />}
                            </Flex>
                            {isFeatureFlagEnabled(import.meta.env.VITE_FEATURE_IN_APP_NOTIFICATIONS) && (
                                <Notification />
                            )}
                            <UserMenu profileName={profileName} email={profileEmail} onSignout={onSignout} />
                        </Flex>
                    )}
                </SimpleGrid>
            ) : (
                <Flex justifyContent="end" alignItems="center" gap={5}>
                    <Button id="login" variant="tertiary" onClick={onSignin}>
                        <Text fontSize="md">{t("login")}</Text>
                    </Button>
                </Flex>
            )}
        </Flex>
    );
};
